import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

export default function AdditionalInformation({ formData, setFormData, formErrors }) {
  const { eligibility } = formData;
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="additional-information-form">
      <h2 className="mb-4">Additional Information</h2>
      {(formData.treatment_interest === 'not_sure' || formData.interest == 'Learn More' || formData.fertility_treatment == 'Other') && (
        <Form.Group controlId="location" className="mb-3">
          <Form.Label className="required">Which location are you looking to visit?</Form.Label>
          <Form.Select name="location" required value={formData.location} onChange={handleChange}>
            <option value="">Select...</option>
            <option value="Toronto">Toronto (160 Bloor St East)</option>
            <option value="Ottawa">Ottawa Area</option>
            <option value="Simcoe">Simcoe County</option>
            <option value="Out of Province">I live out of province</option>
          </Form.Select>
        </Form.Group>
      )}

      <Form.Group controlId="additionalNotes" className="mb-3">
        <Form.Label>Is there anything else you would like to share before we contact you?</Form.Label>
        <Form.Control type="text" name="patient_note" value={formData.patient_note} onChange={handleChange} />
      </Form.Group>

      <Form.Group controlId="referralSource" className="mb-3">
        <Form.Label className="required">How did you hear about our clinic?</Form.Label>
        <Form.Select name="how_did_you_hear_about_our_clinic" required value={formData.how_did_you_hear_about_our_clinic} onChange={handleChange}>
          <option value="">Select...</option>
          <option value="Friend or Family Referral">Friend or Family Referral</option>
          <option value="Online Testimonials (Reviews, Forums, etc.)">Online Testimonials (Reviews, Forums, etc.)</option>
          <option value="Healthcare Provider Referral">Healthcare Provider Referral</option>
          <option value="Employer referral">Employer referral</option>
          <option value="Internet search">Internet search</option>
          <option value="Google Ad">Google Ad</option>
          <option value="Instagram">Instagram</option>
          <option value="LinkedIn">LinkedIn</option>
          <option value="News articles">News articles</option>
          <option value="Other">Other</option>
        </Form.Select>
      </Form.Group>
    </div>
  );
}
